import { useState } from 'react';
import { Field, Input, Button } from './ui';

// Formulario reutilizable para ingresar el ID de paciente.
// Se encarga del estado del input y la validación; el "qué hacer después"
// lo decide quien lo usa, vía la prop onConfirmar.
export default function FormularioIdPaciente({ onConfirmar, textoBoton = 'Continuar' }) {
  const [valor, setValor] = useState('');
  const puedeContinuar = valor.trim().length > 0;

  const enviar = (e) => {
    e.preventDefault();
    if (!puedeContinuar) return;
    onConfirmar(valor.trim());
  };

  return (
    <form onSubmit={enviar}>
      <Field label="ID de paciente" htmlFor="userId" hint="Es un identificador de MongoDB (24 caracteres).">
        <Input id="userId" value={valor} onChange={(e) => setValor(e.target.value)}
               placeholder="Ej. 64f1a2b9c3d4e5f6a7b8c9d0" autoComplete="off" />
      </Field>
      <Button type="submit" block disabled={!puedeContinuar}>{textoBoton}</Button>
    </form>
  );
}
